import React, { useState, useEffect, useCallback, useContext, memo } from "react";

//Context
import { AuthContext } from "../../common/middlewares/Auth";

//Librerias
import axios from "axios";

//Hooks
import { useNavigate } from "react-router-dom";

//Componentes de Noti stack
import { toast } from "react-hot-toast";

//Componentes de Material UI
import { Box, Switch, Typography } from "@mui/material";

//Estilos de Material UI
import { createStyles, createTheme, StyledEngineProvider, ThemeProvider } from "@mui/material/styles";

//Iconos de Material UI
import {
  ViewColumn as ViewColumnIcon,
  EditOutlined as EditOutlinedIcon,
  Edit as EditIcon,
  Clear as ClearIcon,
  DeleteOutline as DeleteOutlineIcon,
  Search as SearchIcon,
  SaveAlt as SaveAltIcon,
  ArrowDownward as ArrowDownwardIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
  Check as CheckIcon,
  FilterList as FilterListIcon,
  Remove as RemoveIcon,
  AddBox as AddBoxIcon,
  Refresh as RefreshIcon,
  DesktopAccessDisabledOutlined as Inactive,
  PersonOutline as PersonIcon,
  AssignmentTurnedInOutlined as AssignmentTurnedInOutlinedIcon,
  VisibilityOutlined as VisibilityOutlinedIcon,
} from "@mui/icons-material";

//Table Material UI
import MaterialTable from "@material-table/core";

// componente 
import ModalCreateRetirement from "../Perfil/encuestaRetiro/Components/ModalCreateRetirement"
import ModalViewRetirement from "../Perfil/encuestaRetiro/Components/ModalViewRetirement"


const administracionStyles = createStyles({
  table: {
    marginTop: "10px",
  },
});

const Administracion = () => {
  //========================================================================================================================
  //========================================= Context  =====================================================================
  //========================================================================================================================
  const authContext = useContext(AuthContext);
  const { token } = authContext;

  //Controlador de Rutas
  const navigate = useNavigate();
  const signalGetOptions = axios.CancelToken.source();
  //========================================================================================================================
  //========================================= Estados  =====================================================================
  //========================================================================================================================
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    flag: false,
    msg: undefined,
  });
  const [options, setOptions] = useState([]);

  const [openModalCreateRetirementSurvey, setOpenModalRetirementSurvey] = useState(false);
  const [openModalViewRetirementSurvey, setOpenModalViewRetirementSurvey] = useState(false);
  const [selectedData, setSelectedData] = useState(null);



  const [inactivos, setInactivos] = useState(false);

  const getOptions = useCallback(
    async (signalGetOptions) => {
      setLoading(true);
      await axios({
        method: "GET",
        baseURL: `${process.env.REACT_APP_API_BACK_PROT_DATALAKE}://${process.env.REACT_APP_API_BACK_HOST_DATALAKE}${process.env.REACT_APP_API_BACK_PORT_DATALAKE}`,
        url: `${process.env.REACT_APP_API_DATALAKE_PERSONACTIVA_GETPERSONACTIVA}`,
        headers: {
          token,
        },
        cancelToken: signalGetOptions.token,
      })
        .then((res) => {
          console.log("getPersonaActiva res:", res.data);
          if (res.data.error) {
            setError({
              flag: true,
              msg: res.data.msg,
            });

            setLoading(false);
          } else {
            setError({
              flag: false,
              msg: undefined,
            });
            setOptions(res?.data?.data ?? []);
            setLoading(false);
          }
        })
        .catch((error) => {
          if (!axios.isCancel(error)) {
            setError({
              flag: true,
              msg: error.message,
            });
            console.error(error);
            setLoading(false);
          }
        });
    },
    [token]
  );

  const getOptionsInactivos = useCallback(async (signalGetOptions) => {
    setLoading(true);
    await axios({
      method: "GET",
      baseURL: `${process.env.REACT_APP_API_BACK_PROT_DATALAKE}://${process.env.REACT_APP_API_BACK_HOST_DATALAKE}${process.env.REACT_APP_API_BACK_PORT_DATALAKE}`,
      url: `${process.env.REACT_APP_API_PERSONAACTIVA_GETPERSONAINACTIVA}`,
      cancelToken: signalGetOptions.token,
      headers: {
        token,
      },
    })
      .then((res) => {
        if (res.data.error) {
          throw new Error(res.data.msg);
        }
        setLoading(false);
        setOptions(res.data.data);
      })
      .catch((error) => {
        setLoading(false);
        if (!axios.isCancel(error)) {
          console.error(error);
          setError({
            flag: true,
            msg: error.message,
          });
        }
      });
  }, [token]);

  const handlerChange = () => {
    setInactivos(!inactivos);
  };

  useEffect(() => {
    if (inactivos) {
      getOptionsInactivos(signalGetOptions);
    } else {
      getOptions(signalGetOptions);
    }

    return () => {
      signalGetOptions.cancel("Abort peticion");
    };
    // eslint-disable-next-line
  }, [getOptions, inactivos]);

  useEffect(() => {
    if (error.flag) {
      toast.error(error.msg);
    }
  }, [error]);

  const classes = administracionStyles;

  const handlerOpenModalCreateRetirementSurvey = () => {
    setOpenModalRetirementSurvey(!openModalCreateRetirementSurvey);
  };


  const handlerOpenModalViewRetirementSurvey = () => {
    setOpenModalViewRetirementSurvey(!openModalViewRetirementSurvey);
  };


  return (
    <Box style={classes.table}>
      <>
        <ModalCreateRetirement
          handleOpenDialog={handlerOpenModalCreateRetirementSurvey}
          rowData={selectedData}
          open={openModalCreateRetirementSurvey}
        />

        <ModalViewRetirement
          handleOpenDialog={handlerOpenModalViewRetirementSurvey}
          rowData={selectedData}
          open={openModalViewRetirementSurvey}
          isTable={true}
        />
      </>

      <StyledEngineProvider injectFirst>
        <ThemeProvider
          theme={createTheme({
            palette: {
              mode: "light",
              primary: {
                main: "#3f51b5",
                dark: "#3f51b5",
                light: "#0288D1",
                contrastText: "#ffff",
              },
              secondary: {
                main: "#ED6F17",
              },
              divider: "#BDBDBD",
              background: {
                default: "#f9f9f9",
                paper: "#ffffff",
              },
              text: {
                primary: "#333333",
                secondary: "#666666",
              },
            },
            components: {
              MuiTableBody: {
                styleOverrides: {
                  root: {
                    fontSize: 11,
                    fontFamily:
                      '"Roboto", "Helvetica", "Arial", sans-serif',
                  },
                },
              },
              MuiTableCell: {
                styleOverrides: {
                  root: {
                    padding: "2px 2px",
                    borderBottom: "1px solid #E0E0E0"
                  },
                },
              },
            },
          })}
        >
          <MaterialTable
            icons={{
              Add: AddBoxIcon,
              Clear: ClearIcon,
              Check: CheckIcon,
              Delete: DeleteOutlineIcon,
              Edit: EditIcon,
              DetailPanel: ChevronRightIcon,
              Export: SaveAltIcon,
              Filter: FilterListIcon,
              FirstPage: FirstPageIcon,
              LastPage: LastPageIcon,
              NextPage: ChevronRightIcon,
              PreviousPage: ChevronLeftIcon,
              Search: SearchIcon,
              ResetSearch: ClearIcon,
              SortArrow: ArrowDownwardIcon,
              ThirdStateCheck: RemoveIcon,
              ViewColumn: ViewColumnIcon,
            }}
            localization={{
              pagination: {
                labelRowsSelect: "filas",
                labelDisplayedRows: "{from}-{to} de {count}",
                firstTooltip: "Primera página",
                previousTooltip: "Página anterior",
                nextTooltip: "Siguiente página",
                lastTooltip: "Última página",
                labelRowsPerPage: "Filas por página",
                labelRows: "Filas"
              },
              toolbar: {
                nRowsSelected: "{0} filas seleccionadas",
                searchTooltip: "Buscar",
                searchPlaceholder: "Buscar",

              },
              header: {
                actions: "Acciones",
              },
              body: {
                emptyDataSourceMessage: "No existe información por mostrar",
                filterRow: {
                  filterTooltip: "Filtro",
                },
                editRow: {
                  deleteText: "Esta seguro de eliminar el registro?",
                },
              },
              selector: {
                okLabel: "aceptar",
                cancelLabel: "Cancelar",
                clearLabel: "Clear",
                todayLabel: "Hoy",
              },
              grouping: {
                placeholder:
                  "Arrasta el nombre de la columna para agrupar los campos",
                groupedBy: "Datos agrupados por: ",
              },
            }}
            columns={[
              {
                title: "Número de documento",
                field: "strIdentificacion",
                type: "string",
              },
              {
                title: "Nombre y apellidos",
                field: "strNombreCompleto",
                type: "string",
              },
              {
                title: "Correo corporativo",
                field: "strEmail",
                type: "string",
              },
            ]}
            isLoading={loading}
            data={options}
            actions={[
              (rowData) => ({
                icon: () => <AssignmentTurnedInOutlinedIcon htmlColor={"#4caf50"} sx={{ fontSize: 16 }} />,
                tooltip: "Activar encuesta retiro",
                onClick: (event, rowData) => {
                    setSelectedData(rowData);
                    handlerOpenModalCreateRetirementSurvey();
                },
              }),
              (rowData) => ({
                icon: () => <EditOutlinedIcon htmlColor="#4caf50" sx={{ fontSize: 16 }} />,
                tooltip: "Editar",
                onClick: (e, rowData) => {
                  let url = `/wilson/perfil/edit/${rowData.strEmail}/${rowData.strNombreCompleto}`;
                  navigate(url);
                },
              }),
              (rowData) => ({
                icon: () => <VisibilityOutlinedIcon color="info" sx={{ fontSize: 16 }} />,
                tooltip: "Ver histórico retiros",
                onClick: (event, rowData) => {
                  setSelectedData(rowData);
                  handlerOpenModalViewRetirementSurvey();
                },
              }),
              {
                icon: () => <PersonIcon color="primary" />,
                tooltip: "Colaboradores Activos",
                hidden: inactivos ? true : false,
                isFreeAction: true,
              },
              {
                icon: () => <Inactive color="primary" />,
                tooltip: "Colaboradores Inactivos",
                hidden: inactivos ? false : true,
                isFreeAction: true,
              },
              {
                icon: () => <RefreshIcon />,
                tooltip: "Refrescar datos",
                isFreeAction: true,
                onClick: () => {
                  inactivos
                    ? getOptionsInactivos(signalGetOptions)
                    : getOptions(signalGetOptions);
                },
              },
            ]}
            title={inactivos ? "Colaboradores Inactivos" : "Colaboradores Activos"}
            options={{
              tableLayout: "auto", // Establece el diseño de la tabla para un ancho fijo
              autoWidth: true, // Ajusta el ancho de las columnas automáticamente
              detailPanelType: "single",
              grouping: false,
              title: true,
              filtering: false,
              search: true,
              exportAllData: true,
              columnsButton: true,
              filterRowStyle: {
                fontSize: 11,
              },
              headerStyle: {
                position: "sticky",
                zIndex: 1,
                top: "0",
                backgroundColor: "#D9D9D9",
                color: "#333",
                fontSize: 11,
                fontWeight: "bold",
              },
              rowStyle: (rowData, index) => ({
                backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff", fontSize: "11px",
              }),
              maxBodyHeight: "380px",
              actionsColumnIndex: -1,
              paging: true,
              pageSizeOptions: [50, 100, 200, 500],
              pageSize: 50,
            }}
          />
        </ThemeProvider>
      </StyledEngineProvider>
      <Box display="flex" justifyContent="flex-end">
        <Typography style={{ marginTop: 8 }}>Colaboradores inactivos</Typography>
        <Switch onChange={handlerChange} color="primary" />
      </Box>
    </Box>
  );
};

export default memo(Administracion);
